<!--
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-07-18 14:42:19
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2022-12-15 18:09:10
 * @FilePath: \ioc_base\src\modules\cameraList\components\fireImg.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <!-- 部件94 blue -->
    <!-- :src="'images/theme/custom/fire/default/SENU094_' + item.value + '.png'" -->

    <img
      v-for="item in defaultList"
      :key="'B' + item.value"
      :ref="'Bdefault' + item.value"
      :src="'images/theme/custom/fire/default/SENU094_' + item.value + '.png'"
      onerror="this.src='/images/theme/newDark/device.png'"
      width="20"
      height="20"
      alt=""
    />
    <img
      v-for="item in defaultList"
      :key="'Bc' + item.value"
      :ref="'Bchecked' + item.value"
      onerror="this.src='/images/theme/newDark/deviceCheck.png'"
      :src="'images/theme/custom/fire/checked/SENU094_' + item.value + '.png'"
      width="20"
      height="20"
      alt=""
    />
    <!-- 主机 87 blue -->

    <img
      v-for="(item, index) in defaultList2"
      :key="'z' + index"
      :ref="'Zdefault' + item.value"
      :src="'images/theme/custom/fire/default/SENU087_' + item.value + '.png'"
      width="20"
      onerror="this.src='/images/theme/newDark/device.png'"
      height="20"
      alt=""
    />
    <img
      v-for="item in defaultList2"
      :key="'c' + item.value"
      :ref="'Zchecked' + item.value"
      onerror="this.src='/images/theme/newDark/deviceCheck.png'"
      :src="'images/theme/custom/fire/checked/SENU087_' + item.value + '.png'"
      width="20"
      height="20"
      alt=""
    />
  </div>
</template>
<script>
import { Dic } from "$utils";
export default {
  data() {
    return {
      defaultValue: "2,3,11,12,13,15,22,24,29,30,31,34,40,45,49,50",
      defaultList: [],
      defaultList2: [],
    };
  },
  created() {
    Dic.find("SENU087").map((item) => {
      // console.log(item)
      if (item.value > 26 && item.value < 30) {
        this.defaultList2.push(item);
      }
    });
    Dic.find("SENU094").map((item) => {
      if (this.defaultValue.indexOf(item.value) != -1) {
        this.defaultList.push(item);
      }
    });
  },
  mounted() {},
};
</script>
